// extracted by mini-css-extract-plugin
export var footer = "_lt-5";
export var fulfillmentInput = "_lt-0";
export var shipDateInput = "_lt-1";
export var shipmentModal = "_lt-2";
export var shipmentModalContent = "_lt-3";
export var tableContainer = "_lt-4";